import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import useReveal from '../hooks/useReveal';
import { programs, steps } from '../mock';

export default function Programs() {
  const ref = useReveal();
  return (
    <div ref={ref} className="max-w-6xl mx-auto px-5 sm:px-8 pt-12">
      <section className="reveal in max-w-2xl">
        <span className="eyebrow text-[#2E6BFF]">Programs</span>
        <h1 className="font-display font-extrabold text-[#0E1726] text-[40px] sm:text-[52px] tracking-tight leading-[1.02] mt-4">
          Choose the support your next chapter needs.
        </h1>
        <p className="text-[#5B6472] text-[17px] leading-relaxed mt-5">
          Focused experiences for individuals, product teams, and organizations—from career growth
          and AI capability to strategy and leadership transformation.
        </p>
      </section>

      <section className="grid md:grid-cols-2 gap-6 mt-12">
        {programs.map((p) => (
          <div key={p.index} className="reveal bg-white rounded-2xl p-7 sm:p-8 shadow-[0_20px_50px_-35px_rgba(14,23,38,0.4)] border-t-[3px] hover:-translate-y-1 transition-transform duration-300" style={{ borderTopColor: p.accent }}>
            <div className="eyebrow" style={{ color: p.accent }}>{p.index} · {p.kicker}</div>
            <h3 className="font-display font-bold text-[#0E1726] text-[24px] mt-3">{p.title}</h3>
            <p className="text-[#5B6472] leading-relaxed mt-3">{p.desc}</p>
            <ul className="mt-5 space-y-3">
              {p.points.map((pt) => (
                <li key={pt} className="flex items-center gap-3 text-[#0E1726] border-b border-black/5 pb-3">
                  <Check size={16} style={{ color: p.accent }} />
                  <span className="text-[15px]">{pt}</span>
                </li>
              ))}
            </ul>
            <Link to={p.kicker === 'LEARN' ? '/enroll' : '/contact'} className="inline-flex items-center gap-1.5 mt-6 font-semibold text-[15px] hover:gap-2.5 transition-all" style={{ color: p.accent }}>
              {p.cta} <ArrowRight size={16} />
            </Link>
          </div>
        ))}
      </section>

      <section className="py-20">
        <div className="reveal max-w-2xl">
          <h2 className="font-display font-extrabold text-[#0E1726] text-[30px] sm:text-[40px] tracking-tight">
            Leave with movement, not more information.
          </h2>
          <p className="text-[#5B6472] text-[17px] mt-4">Every experience is built around a real decision or outcome—not passive content consumption.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {steps.map((s) => (
            <div key={s.n} className="reveal">
              <div className="font-display font-extrabold text-[#2E6BFF] text-[44px] leading-none">{s.n}</div>
              <h3 className="font-display font-bold text-[#0E1726] text-[20px] mt-4">{s.title}</h3>
              <p className="text-[#5B6472] leading-relaxed mt-2">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
